"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _utils = require("../utils");

var _responsive = require("../responsive");

var _RowWithShadow = _interopRequireWildcard(require("../helpers/RowWithShadow"));

var _button = require("../button");

var _icons = require("../icons");

var _propTypes = require("../prop-types");

var _context = require("../context");

var _constants = require("./constants");

var _defaultTitleRenderer = require("./defaultTitleRenderer");

var _core = require("@emotion/core");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  border: none!important;\n\n  :hover {\n    color: ", ";\n  }\n  :focus {\n    :before {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FlyoutCloseButton = (0, _context.styledWithTheme)(_button.Button)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.selectors.color('neutral0');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.selectors.color('neutral10');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.selectors.color('neutral0');
});

var FlyoutContentWithoutDocs = function FlyoutContentWithoutDocs(_ref4) {
  var children = _ref4.children,
      titleText = _ref4.titleText,
      onCloseButtonClick = _ref4.onCloseButtonClick,
      _ref4$closeButtonAltT = _ref4.closeButtonAltText,
      closeButtonAltText = _ref4$closeButtonAltT === void 0 ? _constants.FlyoutContentDefaultProps.closeButtonAltText : _ref4$closeButtonAltT,
      _ref4$renderTitle = _ref4.renderTitle,
      renderTitle = _ref4$renderTitle === void 0 ? _defaultTitleRenderer.defaultTitleRenderer : _ref4$renderTitle,
      buttons = _ref4.buttons,
      _ref4$maxWidth = _ref4.maxWidth,
      maxWidth = _ref4$maxWidth === void 0 ? _constants.FlyoutContentDefaultProps.maxWidth : _ref4$maxWidth,
      dataTestId = _ref4.dataTestId;
  var contentRef = (0, _react.useRef)(null);
  var headerRef = (0, _react.useRef)(null);
  var footerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      footerHasShadow = _useState2[0],
      setFooterHasShadow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      headerHasShadow = _useState4[0],
      setHeaderHasShadow = _useState4[1];

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var viewport = (0, _responsive.useBreakpoints)();
  var isSmallViewport = viewport.matches.s;

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)(),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  var handleScroll = function handleScroll() {
    if (!contentRef.current || !headerRef.current || !footerRef.current) {
      return;
    }

    var _contentRef$current$g = contentRef.current.getBoundingClientRect(),
        contentTop = _contentRef$current$g.top,
        contentBottom = _contentRef$current$g.bottom;

    var _headerRef$current$ge = headerRef.current.getBoundingClientRect(),
        headerBottom = _headerRef$current$ge.bottom;

    var _footerRef$current$ge = footerRef.current.getBoundingClientRect(),
        footerTop = _footerRef$current$ge.top;

    setHeaderHasShadow(contentTop < headerBottom);
    setFooterHasShadow(contentBottom > footerTop);
  }; // Call handleScroll() once on mount to add the shadows if necessary


  (0, _react.useEffect)(function () {
    handleScroll();
  }, []);
  var forwardedMaxWidth = maxWidth === null ? undefined : maxWidth;
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilFlyoutContent',
    dataTestId: dataTestId
  });
  var hasButtons = !!buttons && !!buttons.length;
  var padding = _constants.BODY_PADDING_LARGE_VIEWPORT;
  var headerPadding = _constants.HEADER_PADDING_LARGE_VIEWPORT;
  var footerHorizontalPadding = _constants.BODY_PADDING_LARGE_VIEWPORT;

  if (isSmallViewport) {
    padding = _constants.BODY_PADDING_SMALL_VIEWPORT;
    footerHorizontalPadding = _constants.BODY_PADDING_SMALL_VIEWPORT;
    headerPadding = _constants.HEADER_PADDING_SMALL_VIEWPORT;
  }

  if (isInHighZoomLevel) {
    padding = _constants.BODY_PADDING_IN_HIGH_ZOOM_LEVEL;
    headerPadding = _constants.HEADER_PADDING_IN_HIGH_ZOOM_LEVEL;
    footerHorizontalPadding = 0;
  }

  var footerRowProps = {
    gridGap: _constants.FOOTER_GRID_GAP,
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: [_constants.FOOTER_PADDING, footerHorizontalPadding],
    'data-test-component': 'StencilFlyoutFooter'
  };
  var minHeaderHeight = selectors.constant('headerHeight');
  return (0, _core.jsx)(_layout.Col, (0, _extends2.default)({}, dataTestProps, {
    backgroundColor: "neutral0",
    maxWidth: isSmallViewport ? '100%' : forwardedMaxWidth,
    width: isSmallViewport ? '100%' : undefined,
    height: "100%"
  }), (0, _core.jsx)("div", {
    ref: headerRef
  }, (0, _core.jsx)(_RowWithShadow.default, {
    backgroundColor: "primary70",
    alignItems: "center",
    padding: headerPadding,
    minHeight: minHeaderHeight,
    shadowPosition: _RowWithShadow.ShadowPosition.Bottom,
    hasShadow: headerHasShadow,
    "data-test-component": "StencilFlyoutHeader"
  }, (0, _core.jsx)(_layout.View, {
    id: _constants.FLYOUT_TITLE_ID,
    "data-test-component": "StencilFlyoutTitle"
  }, renderTitle({
    titleText: titleText
  })), (0, _core.jsx)(_layout.Spacer, {
    flex: 1,
    minWidth: "S300"
  }), onCloseButtonClick !== null && (0, _core.jsx)(FlyoutCloseButton, {
    colorScheme: _button.ButtonColorScheme.DarkBackground,
    dataTestComponent: "StencilFlyoutCloseButton",
    icon: (0, _core.jsx)(_icons.IconCross, {
      title: closeButtonAltText
    }),
    onClick: onCloseButtonClick,
    variant: _button.ButtonVariant.Tertiary
  }))), (0, _core.jsx)(_layout.Col, {
    overflow: "auto",
    padding: padding,
    height: "100%",
    onScroll: handleScroll,
    "data-test-component": "StencilFlyoutBody"
  }, (0, _core.jsx)("div", {
    ref: contentRef
  }, children), hasButtons && isInHighZoomLevel && (0, _core.jsx)("div", {
    ref: footerRef
  }, (0, _core.jsx)(_layout.Row, footerRowProps, buttons))), hasButtons && !isInHighZoomLevel && (0, _core.jsx)("div", {
    ref: footerRef
  }, (0, _core.jsx)(_RowWithShadow.default, (0, _extends2.default)({
    hasShadow: footerHasShadow,
    shadowPosition: _RowWithShadow.ShadowPosition.Top
  }, footerRowProps), buttons)));
};

var FlyoutContent = (0, _stencilReactDesc.describe)(FlyoutContentWithoutDocs).description('Panel designed to be used as a flyout.');
FlyoutContent.propTypes = {
  children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the body of the flyout, below the title.'),
  titleText: _stencilReactDesc.PropTypes.string.isRequired.description('Text to display as the title of the flyout.'),
  renderTitle: _stencilReactDesc.PropTypes.func.description('Customizes how the title is displayed.').format("({\n  titleText: string\n}) => ReactNode"),
  onCloseButtonClick: _stencilReactDesc.PropTypes.func.description('Function called when the close button in the flyout header is clicked.'),
  closeButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text used for the close button in the flyout header.'),
  buttons: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.node).description('Array of buttons to be displayed at the bottom of the flyout.'),
  maxWidth: (0, _propTypes.cssValue)().description("Sets the CSS 'max-width' property for the flyout."),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
FlyoutContent.displayName = 'FlyoutContent';
FlyoutContent.defaultProps = (0, _objectSpread2.default)({}, _constants.FlyoutContentDefaultProps);
var _default = FlyoutContent;
exports.default = _default;